import React, { FunctionComponent, useState } from 'react'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'
import app from '../../firebase/initialize'
import { useDispatch } from 'react-redux'

import { ReactComponent as Logo } from '../../components/atoms/Icons/logo.svg'

import * as S from './styled'
import { requestActions } from '../../redux/requests'

interface OwnProps {}

type Props = OwnProps

const SignIn: FunctionComponent<Props> = () => {
  const dispatch = useDispatch()
  const [email, setEmail] = useState('')
  const [linkSent, setLinkSent] = useState(false)
  const auth = getAuth(app)

  function handleClick() {
    setLinkSent(true)
    dispatch(requestActions.auth.sendPasswordReset({ email }))
  }

  return (
    <S.Wrapper>
      <S.Container>
        <Logo height="150" viewBox="0 0 550 550" />
        <S.Title>Återställ lösenord</S.Title>
        {!linkSent && (
          <>
            <S.Paragraph>
              Ange din e-post address så skickar vi en länk för lösenords återställning!
            </S.Paragraph>
            <S.InputWrapper>
              <S.Input
                type="email"
                placeholder="e-post"
                onChange={e => setEmail(e.target.value)}
                required
              />
            </S.InputWrapper>
            <S.Button onClick={handleClick}>Skicka</S.Button>
          </>
        )}{' '}
        {linkSent && (
          <>
            <S.Title>Länken har skickats till din e-post!</S.Title>
            <S.Paragraph>
              Det kan ta några minuter för att få verifikationsmejlet. Kolla gärna skräppost.
            </S.Paragraph>
          </>
        )}
      </S.Container>
    </S.Wrapper>
  )
}

export default SignIn
